import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import FeaturedFilterBubble from './FeaturedFilterBubble';
import styles from './FeaturedFilter.less';

const CATEGORY_EVERYTHING_ID = 999;

const categories = [
  { id: CATEGORY_EVERYTHING_ID, value: 'Everything' },
  { id: 0, value: 'Animals & pets' },
  { id: 2, value: 'Children & youth' },
  { id: 1, value: 'Creative arts & culture' },
  { id: 5, value: 'Disability support' },
  { id: 13, value: 'Emergencies' },
  { id: 3, value: 'Gardens & environment' },
  { id: 11, value: 'Health & medical' },
  { id: 6, value: 'International volunteering' },
  { id: 9, value: 'Local community' },
  { id: 7, value: 'Schools & education' },
  { id: 8, value: 'Social welfare' },
  { id: 14, value: 'Sports' },
];

const types = [{ id: 0, value: 'Featured' }, { id: 1, value: 'Popular' }];

const locations = [{ id: 0, value: 'Everywhere' }, { id: 1, value: 'Near me' }];

class FeaturedFilter extends Component {
  static propTypes = {
    filter: PropTypes.shape({
      categoryId: PropTypes.number.isRequired,
      typeId: PropTypes.number.isRequired,
      locationId: PropTypes.number.isRequired,
    }),
    onChange: PropTypes.func.isRequired,
  };

  getSelection(categoryId, typeId, locationId) {
    const category = categories.find(c => c.id === categoryId);
    const type = types.find(t => t.id === typeId);
    const location = locations.find(l => l.id === locationId);

    return { category, type, location };
  }

  handleCategoryChanged = id => {
    const {
      filter: { locationId },
      onChange,
    } = this.props;
    const selection = this.getSelection(id, 1, locationId);

    onChange(selection);
  };

  handleTypeChanged = id => {
    const { onChange } = this.props;
    const selection = this.getSelection(CATEGORY_EVERYTHING_ID, id, 0);

    onChange(selection);
  };

  handleLocationChanged = id => {
    const {
      filter: { categoryId },
      onChange,
    } = this.props;
    const selection = this.getSelection(categoryId, 1, id);

    onChange(selection);
  };

  render() {
    const {
      filter: { categoryId, typeId, locationId },
    } = this.props;

    return (
      <div styleName="container">
        <span className="dna-h1">Show me </span>
        <FeaturedFilterBubble
          title="Category"
          options={categories}
          selectedId={categoryId}
          onSelectionChanged={this.handleCategoryChanged}
        />
        <span className="dna-h1">thatʼs </span>
        <FeaturedFilterBubble
          title="Type"
          options={types}
          selectedId={typeId}
          onSelectionChanged={this.handleTypeChanged}
        />
        <FeaturedFilterBubble
          title="Location"
          options={locations}
          selectedId={locationId}
          onSelectionChanged={this.handleLocationChanged}
        />
      </div>
    );
  }
}

export default CSSModules(FeaturedFilter, styles);



// WEBPACK FOOTER //
// ./src/components/Home/FeaturedFilter.js